import type { FC } from 'react';
import { Headline as HeadlineComponent, type HeadlineProps } from './components/Headline';
import { Counter as CounterComponent, type CounterProps } from './components/Counter';
import { KPI as KPIComponent, type KPIProps } from './components/KPI';
import { Label as LabelComponent, type LabelProps } from './components/Label';
import { Paragraph as ParagraphComponent, type ParagraphProps } from './components/Paragraph';
import {
  AssistiveMessage as AssistiveMessageComponent,
  type AssistiveMessageProps,
} from './components/AssistiveMessage';

export enum TypographyItem {
  Headline = 'Headline',
  Counter = 'Counter',
  KPI = 'KPI',
  Label = 'Label',
  Paragraph = 'Paragraph',
  AssistiveMessage = 'AssistiveMessage',
}

export type TypographyItemProps = {
  [TypographyItem.Headline]: HeadlineProps;
  [TypographyItem.Counter]: CounterProps;
  [TypographyItem.KPI]: KPIProps;
  [TypographyItem.Label]: LabelProps;
  [TypographyItem.Paragraph]: ParagraphProps;
  [TypographyItem.AssistiveMessage]: AssistiveMessageProps;
};

const TYPOGRAPHY_ITEM_MAP = {
  [TypographyItem.Headline]: HeadlineComponent,
  [TypographyItem.Counter]: CounterComponent,
  [TypographyItem.KPI]: KPIComponent,
  [TypographyItem.Label]: LabelComponent,
  [TypographyItem.Paragraph]: ParagraphComponent,
  [TypographyItem.AssistiveMessage]: AssistiveMessageComponent,
} satisfies Readonly<{ [T in TypographyItem]: FC<TypographyItemProps[T]> }>;

/**
 * Object containing all the typography components.
 * @example <Typography.Headline>Headline 1</Typography.Headline>
 */
export const Typography = Object.freeze(TYPOGRAPHY_ITEM_MAP);
